import type { Rule } from 'antd/es/form';
import { FormattedMessage } from '@/components/formatted_message/FormattedMessage';
import { COMMON_FORM_ERRORS_TRANSLATED } from '@/common/messages/form/errors';

const phoneRegExp = /^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})?(?:\s?\(\d+\))?(?:[-/\s.]|\d)+$/;

export const phoneNumberRule: Rule = {
  pattern: phoneRegExp,
  message: <FormattedMessage {...COMMON_FORM_ERRORS_TRANSLATED.phone} />,
};

/** Required text field that also rejects whitespace-only input. ENMON-3876. */
export const requiredTextRule: Rule = { required: true, whitespace: true };
